import { Group, Path, Rect } from 'react-konva';
import { UseKonvaCursor } from '../../hooks/useKonvaCursor';
import { KonvaEventObject } from 'konva/lib/Node';

interface CanvasSVGIconProps extends Partial<UseKonvaCursor> {
  paths: string[];
  x: number;
  y: number;
  height: number;
  width: number;
  viewBoxSize: number;
  fill: string;
  onClick(e: KonvaEventObject<MouseEvent>): void;
}
const CanvasSVGIcon = ({
  paths,
  x,
  y,
  width,
  height,
  viewBoxSize,
  fill,
  onMouseEnter,
  onMouseLeave,
  onClick,
}: CanvasSVGIconProps) => {
  const scaleX = width / viewBoxSize;
  const scaleY = height / viewBoxSize;

  return (
    <Group>
      <Rect
        x={x}
        y={y}
        height={height}
        width={width}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        onClick={onClick}
      />
      {paths.map((data, index) => (
        <Path
          key={index}
          data={data}
          x={x}
          y={y}
          scaleX={scaleX}
          scaleY={scaleY}
          fill={fill}
          listening={false}
        />
      ))}
    </Group>
  );
};

export default CanvasSVGIcon;
